import { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Box from "@cloudscape-design/components/box";
import Icon from "@cloudscape-design/components/icon";
import ConversationBubble from "./ConversationBubble";

function ConversationPanel({ messages = [] }) {
  const { t } = useTranslation();
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <div className="conversation-panel-container">
      <div className="panel-header">
        <h3>{t("conversation.panel.title")}</h3>
      </div>
      
      <div className="conversation-messages" role="log">
        {messages.length === 0 ? (
          <div className="panel-empty-state">
            <Icon name="contact" size="big" />
            <Box color="text-body-secondary">{t("conversation.panel.empty")}</Box>
          </div>
        ) : (
          <>
            {messages.map((message) => (
              <ConversationBubble key={message.event_id} message={message} type={message.type} />
            ))}
            <div ref={messagesEndRef} />
          </>
        )}
      </div>
    </div>
  );
}

export default ConversationPanel;
